import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {isHoomvipApiRequest} from './http-api-scope';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isHoomvipApiRequest(req.url)) {
    return next(req);
  }

  const token = inject(HoomvipStorage).getToken();
  if (!token) return next(req);

  const authReq = req.clone({
    setHeaders: {Authorization: `Bearer ${token}`},
  });
  return next(authReq);
};
